import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getAliasFromType, lazyWithPreload } from '../../../utils/Utils';
import CreateEntityModal from './CreateEntityModal';
import Popover from 'antd/lib/popover';
import { EntityTypes } from '../../../constants';
import Modal from 'antd/lib/modal';
import CreateEntityOption from './CreateEntityOption';
import './CreateEntity.scss';
import { faHashtag, faTrophy } from '@fortawesome/pro-regular-svg-icons';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import useOrg from '../../../services/hooks/useOrg';
import { useParams } from 'react-router-dom';

const NewInboxFlow = lazyWithPreload(
  () => import(/* webpackChunkName: "NewInboxFlow", webpackPrefetch: true */ '../NewInboxFlow'),
);

const CreateEntity = () => {
  const { orgPath = '' } = useParams();
  const { data: org } = useOrg({ orgPath });
  const orgMeta = org?.metadata;
  const orgIsEnterprise = org?.isEnterprise;

  const [visible, setVisible] = useState(false);
  const [entityModalVisible, setEntityModalVisible] = useState(false);
  const [entityTypeSelected, setEntityTypeSelected] = useState('');

  const onVisibleChange = (visible: boolean) => {
    NewInboxFlow.preload();
    setVisible(visible);
  };

  const toggleCreateEntity = (entityType: string = '') => {
    setEntityTypeSelected(entityType);
    setEntityModalVisible(!entityModalVisible);
    setVisible(false);
  };

  const togglePopover = async () => {
    if (orgIsEnterprise !== undefined) {
      setVisible(!visible);
    }
  };

  return (
    <>
      <Popover
        overlayClassName="create-entity"
        placement="bottom"
        trigger="click"
        open={visible}
        onOpenChange={onVisibleChange}
        content={
          <>
            <ul className="popover-nav">
              <CreateEntityOption
                entityType={EntityTypes.BOARD}
                toggleCreateEntity={toggleCreateEntity}
                icon={<FontAwesomeIcon icon={faHashtag} className="gigg-menu__icon" fixedWidth />}
              />
              {orgMeta?.isCompetitionEnabled && (
                <CreateEntityOption
                  entityType={EntityTypes.COMPETITION}
                  toggleCreateEntity={toggleCreateEntity}
                  icon={<FontAwesomeIcon icon={faTrophy} className="gigg-menu__icon" fixedWidth />}
                />
              )}
            </ul>
          </>
        }
      >
        <button className="btn btn-primary btn-large full-width create-board-btn" onClick={togglePopover}>
          <FontAwesomeIcon icon={faPlus} /> <span className="margin-left-xs">New</span>
        </button>
      </Popover>
      <Modal
        open={entityTypeSelected === EntityTypes.BOARD && entityModalVisible}
        onCancel={() => toggleCreateEntity(EntityTypes.BOARD)}
        destroyOnClose
        width={768}
        footer={null}
        closable={false}
        maskClosable={false}
        title={
          <span className="flex-container align-center">
            <FontAwesomeIcon icon={faPlus} className="margin-right-sm" />
            Create a new {getAliasFromType(EntityTypes.BOARD)}
          </span>
        }
      >
        <NewInboxFlow onClose={toggleCreateEntity} />
      </Modal>
      <CreateEntityModal
        visible={entityTypeSelected === EntityTypes.COMPETITION && entityModalVisible}
        toggleCreateEntity={toggleCreateEntity}
        onSuccess={() => setEntityModalVisible(false)}
        entityType={EntityTypes.COMPETITION}
      />
    </>
  );
};

export default CreateEntity;
